import { render, staticRenderFns } from "./CatalogueSupplier.vue?vue&type=template&id=43af88a8"
import script from "./CatalogueSupplier.vue?vue&type=script&lang=js"
export * from "./CatalogueSupplier.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports